import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { updateShopById, getListShops, getAuthUrlTiktok, registerTiktokWebhook, unsubscribeTiktokWebhook } from '../../services/apis';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import { PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { BASE_URL } from '../../settings/config';
import ModalEditShop from './component/ModalEditShop';

const ListShopPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [authUrl, setAuthUrl] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Shop name',
            dataIndex: 'shop_name',
            key: 'shop_name',
            render: (text, record, index) => <div style={{ paddingLeft: 12 }}><a onClick={() => handleEditShop(record)}>{text}</a></div>,
        },
        {
            title: 'Shop code',
            dataIndex: 'custom_code',
            key: 'custom_code',
            render: (text, record, index) => <div style={{ paddingLeft: 12 }}>{text}</div>,
        },
        {
            title: 'Create at',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record, index) => <div style={{ paddingLeft: 12 }}>{text}</div>,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: 200,
            align: 'center',
            render: (text, record) => (
                <>
                    <Popconfirm
                        title={record?.is_webhook_connected ? "Bạn có chắc muốn huỷ kết nối order?" : "Bạn có chắc muốn kết nối order?"}
                        onConfirm={() => handleWebhook(record)}
                        okText="Có"
                        cancelText="Không"
                    >
                        <Button
                            type="primary"
                            size='small'
                            danger={record?.is_webhook_connected ? true : false}
                        >
                            {record?.is_webhook_connected ? 'Huỷ kết nối' : 'Kết nối order'}
                        </Button>



                    </Popconfirm>
                    &nbsp; &nbsp;
                    {
                        !record?.is_webhook_connected ?
                            <Popconfirm
                                title="Bạn có chắc muốn xoá shop này?"
                                onConfirm={() => handleDeleteShop(record)}
                                okText="Có"
                                cancelText="Không"
                            >
                                <Button
                                    type="default"
                                    size='small'
                                    danger
                                >
                                    Xoá
                                </Button>
                            </Popconfirm> : null
                    }


                </>



            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleEditShop = (record) => {
        setItemSelected(record);
        setShowModal(true);
    }

    const handleWebhook = async (record) => {
        debugger
        if (!record?.is_webhook_connected) {
            registerWebhook(record?.shop_id, record?.shop_name);
        } else {
            unsubscribeWebhook(record?.shop_id);
        }
    }

    const handleDeleteShop = async (record) => {
        try {
            const params = {
                id: record?.id,
                status: 2
            }
            setLoading(true);
            const res = await updateShopById(params);
            setLoading(false);
            consoleLogUtil("deleteShop", res);
            if (res && res.status === 1) {
                message.success("Xoá shop thành công");
                getDataShops(true);
            } else {
                message.error(res?.message ?? 'Có lỗi xảy ra');
            }
        } catch (error) {
            setLoading(false);
            message.error('Có lỗi xảy ra');
            consoleLogUtil("error", error);
        }
    }

    const unsubscribeWebhook = async (shopId) => {
        try {
            const params = {
                shop_id: shopId,
            }
            setLoading(true);
            const res = await unsubscribeTiktokWebhook(params);
            setLoading(false);
            consoleLogUtil("unsubscribeWebhook", res);
            if (res && res.status === 1) {
                message.success("Huỷ kết nối order thành công");
                getDataShops(true);
            }
        } catch (error) {
            setLoading(false);
            consoleLogUtil("error", error);
        }
    }

    const registerWebhook = async (shopId, shop_name) => {
        try {
            const params = {
                shop_id: shopId,
                shop_name: shop_name,
                baseUrl: BASE_URL
            }
            setLoading(true);
            const res = await registerTiktokWebhook(params);
            setLoading(false);
            consoleLogUtil("registerWebhook", res);
            if (res && res.status === 1) {
                message.success("Đăng ký webhook thành công");
                getDataShops(true);
            }
        } catch (error) {
            setLoading(false);
            consoleLogUtil("error", error);
        }
    }

    const getDataShops = async (showLoading) => {
        try {
            const params = {
                name: form.getFieldValue('name') ?? '',
            }
            if (showLoading) setLoading(true);
            const res = await getListShops(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
            } else {
                message.error(res.message);
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }
    const handleClickOpenLinkAuth = () => {
        window.open(authUrl, '_self');
    }
    const handleSaveShop = async (data) => {
        try {
            const params = {
                custom_code: data?.custom_code,
                id: data?.id,
            }
            setLoading(true);
            const res = await updateShopById(params);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Cập nhật thành công');
                getDataShops(true);
                setShowModal(false);
            } else {
                message.error(res?.message ?? 'Có lỗi xảy ra');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const getDataUrl = async () => {
        setLoading(true);
        // Call api to get authen url
        const res = await getAuthUrlTiktok();
        consoleLogUtil("res", res);
        if (res && res.status === 1) {
            setAuthUrl(res?.data?.auth_url);
        } else {
            message.error("Lấy url xác thực thất bại");
        }
        setLoading(false);
    }
    const onFinish = async (dataForm) => {
        getDataShops(true);
    };


    useEffect(() => {
        Promise.all([
            getDataShops(true),
            getDataUrl()
        ]).then(() => {
        }).catch((err) => {
            consoleLogUtil("err", err);
        }).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" icon={<SearchOutlined />} htmlType="submit">
                                Tìm kiếm
                            </Button>
                            <Button type="primary" danger icon={<PlusCircleOutlined />} onClick={handleClickOpenLinkAuth}>
                                Thêm TikTok shop
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                className='table-book custom-table'
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
            />
            <ModalEditShop
                visible={showModal}
                data={itemSelected}
                onCancel={() => setShowModal(false)}
                onSave={handleSaveShop}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListShopPage);